import {useState,useRef,useEffect} from 'react';
import Link from 'next/link';
import Image from 'next/image';
import dynamic from 'next/dynamic';
import Select from 'react-select';
import {Maps} from './../../../js/prefix.js';
import styles from './../../../css/pc/login/login.module.scss';
import Modal from 'react-modal';
import { ToastContainer,toast ,Zoom} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {sendSms,loginWithSms,jsonpSso,getQCaptEncryptAppid} from './../../../service/loginService';
import {useRouter} from 'next/router';
import Cookies from 'js-cookie';
import {tencentCaptchaId} from '@/config/config';

const customStyles = {
    container:(provided, state)=>({
        ...provided,
        width:150,
        fontSize:16,
    }), 
    valueContainer:(provided, state)=>({
        width:120,
        fontSize:16,
    }), 
    indicatorsContainer:(provided, state)=>({
        ...provided,
        fontSize:16,
    }), 
    indicatorSeparator:(provided, state)=>({
        ...provided,
        display:'none',
    }), 
    dropdownIndicator:(provided, state)=>({
        ...provided,
        paddingRight:0
    }),
    input:(provided, state)=>({
        ...provided,
        height:36,
        lineHeight:'36px',
        margin:0,
        padding:0,
        position:'absolute',
        top:'50%',
        transform:'translateY(-50%)',
    }),
    menu: (provided, state) => ({
        ...provided,
        width:200,
        borderBottom: '1px dotted pink',
        color: state.selectProps.menuColor,
        padding: 0,
        margin:0
    }),
    menuList:(provided, state)=>({
        ...provided,
        maxHeight:'200px'
    }), 
    option:(provided, state)=>({
        ...provided,
        fontSize:16,
        color:'#8691a7',
        background:state.isSelected||state.isFocused?'#f6f6f6':'none'
    }), 
    control: (_, { selectProps: { width }}) => ({
        display:'flex',

    }),
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition ,width:'120px'};
    }
}
const ThirdBindModal_PC=(props)=>{
    try{
        const router=useRouter();
        const returnUrl=router.query.returnUrl?router.query.returnUrl:'https://www.fx168news.com';
        const sourceCode=router.query.sourceCode;
        const parameters=props.params;
        const flag=props.flag;
        const [selectedOption, setSelectedOption] = useState({value:props.prefix,label:props.prefix});
        const [captchaIns, setCaptchaIns] = useState('');
        const [id, setId] = useState('');
        const [mobile, setMobile] = useState('');
        const [code, setCode] = useState('');
        const [codeStatus, setCodeStatus] = useState(true);
        const [count, setCount] = useState(60);
        const [loading, setLoading] = useState(false);
        const mobileRef = useRef();
        const roamRef = useRef();
        let codeCount=60;
        let timer=null;
        let captchaLoaded=false;
        Modal.setAppElement('#app');
        const bindStyles = {
            overlay:{
                backgroundColor:'rgba(0,0,0,0.5)'
            },
            content:{
                top:'50%',
                left:'50%',
                right:'auto',
                bottom:'auto',
                marginRight:'-50%',
                transform:'translate(-50%, -50%)',
                width:'370px',
                padding:'30px 40px',
                borderRadius:'4px'
            }
        };

        useEffect(()=>{
            setSelectedOption({value:props.prefix,label:props.prefix});
        },[props.prefix])
        
        useEffect(()=>{
            if (parameters.modalIsOpen) {
                initCaptcha();
            }
        },[parameters.modalIsOpen]);

        // 定义回调函数
        const callback=(res)=> {
            if (res.ret === 0) {
                handleCodeSubmit(roamRef.current.props.value,mobileRef.current.value,res.ticket,res.randstr);
            }
        }
        // 定义验证码js加载错误处理函数
        const loadErrorCallback=() =>{
            var appid = tencentCaptchaId
            // 生成容灾票据或自行做其它处理
            var ticket = "terror_1001_" + appid + "_" + Math.floor(new Date().getTime() / 1000)
            callback({
                ret: 300,
                randstr: "@" + Math.random().toString(36).substr(2),
                ticket: ticket,
                errorCode: 1001,
                errorMessage: "jsload_error"
            })
        }
        const initCaptcha=async()=>{
            try {
                const result=await getQCaptEncryptAppid({});
                if(result.code==0){
                    const captcha = new TencentCaptcha(tencentCaptchaId, callback, {aidEncrypted: result.data });
                    setCaptchaIns(captcha);
                    captchaLoaded=true;
                }else{
                    toast.error('获取腾讯云验证码加密appid失败',{toastId:'customId'});
                }
            } catch (error) {
                // 加载异常，调用验证码js加载错误处理函数
                loadErrorCallback()
            }
        }
        // 监听需要绑定的 button 的点击事件，手动调用实例的verify方法来验证
        const handleGetCode=(e)=>{
            let phone=trim(mobile);
            let reg=/^1[2|3|4|5|6|7|8|9]\d{9}$/;
            if(phone===''){
                toast.error("手机号不能为空！",{toastId:'customId2'});
                return false;
            }
            if(selectedOption.value=='中国+86'&&!reg.test(phone)){
                toast.error("请检查手机号码！",{toastId:'customId2'});
                return false;
            }
            // 手动调用verify方法
            captchaIns && captchaIns.show();
        }
        //删除字符串两侧空格
        const trim=(str)=>{
            return str.replace(/(^\s*)|(\s*$)/g, "");
        }
        const handleMobilePost=(e)=>{
            const val=e.target.value;
            setMobile(val);
        }
        const handleCodePost=(e)=>{
            const val=e.target.value;
            setCode(val);
        }
        //获取验证码提交
        const handleCodeSubmit=async(roam,mobile,captchaValidate,randstr)=>{
            let phone=roam.value.split('+')[1]=='86'?mobile:('+'+roam.value.split('+')[1]+mobile);
            setCodeStatus(false);
            timer=setInterval(function(){
                if(codeCount<=1){
                    setCodeStatus(true);
                    codeCount=60;
                    setCount(codeCount)
                    clearInterval(timer);
                }else{
                    codeCount=codeCount-1;
                    setCount(codeCount)
                }
            },1000);
            const res=await sendSms({mobile:phone,ticket:captchaValidate,randstr:randstr,checkVersion:1});
            if(res.code==0){
                setId(res.data.id);
                toast.success("发送成功！",{toastId:'customId2'});
            }else{
                setCodeStatus(true);
                setCount(60);
                clearInterval(timer);
                toast.error(res.data||"发送失败！",{toastId:'customId2'});
            }
        }
        //单点登录设置
        const handleSSO=(list)=>{
            for(let i=0;i<list.length;i++){
                jsonpSso(list[i])                 
            }
        }
        const handleSubmit=async()=>{
            if(loading){return ;}
            const res=await loginWithSms({code:code,id:id,loginMedia:(!flag?1:2),version:'',uStr:parameters.ustr,sourceCode:sourceCode});
            setLoading(true);
            if(res.code==0){
                Cookies.set('t',res.data.t,{expires:7,path:'/',domain:document.domain.split('.').slice(-2).join('.'),secure:true});
                toast.success("绑定成功！",{toastId:'customId2'});
                if(returnUrl){
                    setTimeout(function(){location.href=returnUrl},1000);
                }
                
                handleSSO(res.data.sso);
                parameters.closeBind();
            }else{
                toast.error(res.data||"绑定失败！",{toastId:'customId2'});
            }
            setLoading(false);
        }
        return (
            <Modal
                isOpen={parameters.modalIsOpen}
                style={bindStyles}
                onRequestClose={parameters.closeBind}
                contentLabel="Bind Modal"
            >
                <div className={styles.bindModal}>
                    <h2>绑定手机号</h2>
                    <div className={styles.phoneItem}>
                        <Select
                            placeholder="请选择地区"
                            defaultValue={Maps[0]}
                            value={selectedOption}
                            onChange={(val)=>{setSelectedOption(val);localStorage.setItem("countryPrefix", val['value']);props.setPrefix(val['value'])}}
                            options={Maps}
                            ref={roamRef}
                            styles={customStyles}
                            noOptionsMessage={()=>'没有搜索结果'}
                        />
                        <span className={styles.divider}></span>
                        <input type="text" className={styles.phoneInput} ref={mobileRef} value={mobile} onChange={handleMobilePost} placeholder="手机号" />
                    </div>
                    <div className={styles.codeItem}>
                        <input type="text" className={styles.codeInput} placeholder="输入验证码" value={code} onChange={handleCodePost} />
                        {codeStatus?(
                            <span className={styles.getCode} onClick={handleGetCode}>获取验证码</span>
                        ):(
                            <span className={styles.codeCount}>{count}秒</span>
                        )}
                    </div>
                    <div className={styles.bindItem}>
                        <button onClick={handleSubmit}>绑定</button>
                    </div>
                    <div className={styles.close} onClick={parameters.closeBind}></div>
                </div>
            </Modal>
        );
    }catch(e){
        console.log(e);
        return null;
    } 
};

export default ThirdBindModal_PC;